import { observer } from "mobx-react-lite";
import { useMatchStatsStore } from "../../../stores/StoreContext";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/TCText/TCText";

export const CourtCoverageOptionsView = observer(() => {
  const matchStatsStore = useMatchStatsStore();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        overflowX: "auto",
        whiteSpace: "nowrap",
        justifyContent: "center",
      }}>
      {Array.from(matchStatsStore.courtCoverageMap.keys()).map((item) => (
        <div style={{ display: "inline-block" }} key={item}>
          <CourtCoverageFilterItem item={item} />
        </div>
      ))}
    </div>
  );
});

interface CourtCoverageItemProps {
  item: string;
}

export const CourtCoverageFilterItem = observer(
  ({ item }: CourtCoverageItemProps) => {
    const matchStatsStore = useMatchStatsStore();
    return (
      <div
        onClick={() => matchStatsStore.setSelectedCourtCoverage(item)}
        style={{
          borderRadius: 12,
          padding: "8px 16px",
          backgroundColor:
            item === matchStatsStore.selectedCourtCoverage
              ? Colors.darkBrown
              : Colors.lightGreyBackground,
        }}>
        <TCText
          value={item}
          style={{
            fontWeight: "500",
            fontSize: 11,
            color:
              item === matchStatsStore.selectedCourtCoverage
                ? Colors.white
                : Colors.black,
          }}
        />
      </div>
    );
  }
);
